module.exports = __webpack_public_path__ + "static/img/product4.e471d3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/purple/product4.png
// module id = imxc
// module chunks = 0